import { render, staticRenderFns } from "./AccessruleDetails.vue?vue&type=template&id=33ed5584&scoped=true&"
import script from "./AccessruleDetails.vue?vue&type=script&lang=js&"
export * from "./AccessruleDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccessruleDetails.vue?vue&type=style&index=0&id=33ed5584&scoped=true&lang=css&"
import style1 from "./AccessruleDetails.vue?vue&type=style&index=1&id=33ed5584&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed5584",
  null
  
)

export default component.exports